var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditExperienceItem.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditExperienceItem.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditExperience.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditExperience.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditExperienceItem.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditExperience.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileEditExperienceItem")) {
var t_7 = t_4.MemberProfileEditExperienceItem;
} else {
cb(new Error("cannot import 'MemberProfileEditExperienceItem'")); return;
}
context.setVariable("MemberProfileEditExperienceItem", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"MemberProfileEditExperience\">\n        <div class=\"MemberProfileEditExperience-body  MemberProfileEdit-scrollbox\">\n            <div class=\"MemberProfileEditExperience-body-scrollBlock\">\n                <div class=\"MemberProfileEditExperience-body-scrollBlock-inner\">\n                    <form class=\"MemberProfileEditExperience-body-form\">\n                        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"experiences") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"experiences")),"length"))) {
t_9 += "\n                            ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"experiences");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                                ";
t_9 += runtime.suppressValue((lineno = 12, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditExperienceItem"), "MemberProfileEditExperienceItem", context, [runtime.makeKeywordArgs({"data": t_13})])), env.opts.autoescape);
t_9 += "\n                            ";
;
}
}
frame = frame.pop();
t_9 += "\n                        ";
;
}
else {
t_9 += "\n                            ";
t_9 += "\n                            ";
t_9 += runtime.suppressValue((lineno = 16, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditExperienceItem"), "MemberProfileEditExperienceItem", context, [runtime.makeKeywordArgs({"data": {}})])), env.opts.autoescape);
t_9 += "\n                        ";
;
}
t_9 += "\n                    </form>\n                    <div class=\"MemberProfileEditExperience-body-form-addInput\"><span>+</span>Add experience</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"MemberProfileEditExperience-buttons\">\n            <div class=\"MemberProfileEditExperience-buttons-button MemberProfileEditExperience-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditExperience-buttons-button MemberProfileEditExperience-buttons-button--save\">\n                save\n            </div>\n        </div>\n\n        <div class=\"MemberProfileEditExperience-info\">\n            <div class=\"MemberProfileEditExperience-infoIcon\">?</div>\n            <div class=\"MemberProfileEditExperience-infoPopup\">\n                <span>If you'd like to make your profile stronger and have specific experience appear in the member search results, be sure to include it here. <span class=\"MemberProfileEditExperience-infoPopup-dragText\">If you'd like to reorder these items, simply hold and drag the hamburger icon of the experience you'd like to move up or down.</span></span>\n                <div class=\"MemberProfileEditExperience-infoPopupCorner\"></div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MemberProfileEditExperience");
context.setVariable("MemberProfileEditExperience", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditExperience.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditExperience.jinja
// module id = 115
// module chunks = 0